import { cn } from '@/lib/utils';

interface BreadcrumbItem {
  label: string;
  active?: boolean;
  onSelect?: () => void;
}

interface BreadcrumbBarProps {
  items: BreadcrumbItem[];
  /** Laptop-sized viewport: tighter padding, single truncated line instead of horizontal scroll. */
  compact?: boolean;
}

export function BreadcrumbBar({ items, compact = false }: BreadcrumbBarProps) {
  if (!items.length) return null;

  return (
    <div
      className={cn(
        'sticky z-40 bg-[#020617]/90 backdrop-blur border-b border-white/10 px-4',
        compact ? 'top-12 py-1' : 'top-16 py-2'
      )}
    >
      <nav
        aria-label="Breadcrumb"
        className={cn(
          'font-broadcast text-[10px] uppercase tracking-wider text-white/40 flex items-center gap-2 whitespace-nowrap',
          compact ? 'overflow-hidden' : 'overflow-x-auto'
        )}
      >
        {items.map((item, index) => (
          <div
            key={`${item.label}-${index}`}
            className={cn('flex items-center gap-2', compact && 'min-w-0 shrink last:shrink-0')}
          >
            {index > 0 ? <span className="text-white/30">{'>'}</span> : null}
            {item.onSelect ? (
              <button
                type="button"
                onClick={item.onSelect}
                data-testid="breadcrumb-tournament"
                className={cn(
                  'min-h-11 md:min-h-0 px-1 -mx-1 text-left uppercase tracking-wider text-white/70 hover:text-[#D4AF37]',
                  compact && 'truncate'
                )}
              >
                {item.label}
              </button>
            ) : (
              <span
                className={cn(
                  item.active ? 'text-[#D4AF37]' : 'text-white/60',
                  compact && 'truncate'
                )}
              >
                {item.label}
              </span>
            )}
          </div>
        ))}
      </nav>
    </div>
  );
}
